export default "__VITE_ASSET__fjeJk1gC__"